import logErrors from '@nykaa/nes-logger/logErrors';
import { ApiHelper } from 'shared/api';
import { ROUTES, getUrl, getMartechUrl } from 'shared/api/urls';
import { transformConfigFlags, transformTruecallerStatus } from './transformer';
import { queryStringFromParams } from 'shared/helpers/utils/url';
import { logger } from 'shared/logging';
import { ERROR_FETCHING_BREADCRUMBS } from './constants';

const ERROR_FETCHING_CONFIG = 'Error fetching config flags';
const CREDENTIAL = 'credential';

export const getConfigFlags = async () => {
  // const url = getUrl(ROUTES.CONFIG_FLAGS);
  const url = process.env.CONFIG_FLAGS_URL as string;
  try {
    const { data } = await ApiHelper(url, 'get');

    const transformedConfigFlags = transformConfigFlags(data);
    return transformedConfigFlags;
  } catch (error) {
    // ! FIXME: use the new logging solution
    logErrors(error, `${ERROR_FETCHING_CONFIG} :url=${url}`);
    return null;
  }
};

export const getGeoSubdivision = async () => {
  const url = getUrl(ROUTES.GEO_SUBDIVISION);
  try {
    const { data } = await ApiHelper(url, 'get');

    if (data && data.response) {
      return data.response;
    }
    return [];
  } catch (error) {
    logger.error(error, `Error fetching get subdivision data: url=${url}`);
    throw error;
  }
};

export const getOneTapData = async (params: any) => {
  const { credential, state } = params;
  const url = getUrl(ROUTES.ONE_TAP);
  const queryString = queryStringFromParams({ state });
  const formData = new FormData();
  formData.append(CREDENTIAL, credential);
  try {
    const data = await ApiHelper(`${url}${queryString}`, 'POST', formData);
    return data;
  } catch (e) {
    logger.error(e, `Error fetching one tapData: url=${url}`);
    throw e;
  }
};

export const getRequestId = async () => {
  const queryParams = {
    domain: __PLATFORM__,
    platform: 'WEB',
    user_version: 'v2',
  };

  const url = '/gateway-api/truecaller/v1/initiate';
  try {
    const { data: response } = await ApiHelper(`${url}`, 'post', queryParams);
    const { response: data } = response || {};
    return data?.requestId;
  } catch (e) {
    logger.error(e, `Error fetching truecallerId: url=${url}`);
    throw e;
  }
};

interface TruecallerProps {
  requestId: string;
}

export const getTrueCallerStatus = async (requestParams: TruecallerProps) => {
  const url = '/gateway-api/truecaller/v1/status';
  try {
    const { data: response } = await ApiHelper(`${url}`, 'post', requestParams);
    return transformTruecallerStatus(response);
  } catch (e) {
    logger.error(e, `Error fetching truecallerStatus: url=${url}`);
    throw e;
  }
};

export const getBreadcrumbs = async (id: string) => {
  const url = getMartechUrl(ROUTES.BREADCRUMBS);
  // FIXME: get this from remote config
  const domain = `${__PLATFORM__}_uae`;
  try {
    const { data } = await ApiHelper(`${url}?id=${id}&domain=${domain}`, 'get');
    logger.info(`Response received breadcrumbs with id=${id}`);
    return data?.response;
  } catch (error) {
    logger.error(error, ERROR_FETCHING_BREADCRUMBS);
    return null;
  }
};

export const getBreadcrumbsWithTimeout = async (
  id: string,
  timeout: number = 100
): Promise<any> =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(
        new Error(
          `Request timed out for breadcrumbs with id=${id} and timeout=${timeout}`
        )
      );
    }, timeout);

    getBreadcrumbs(id)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
